import { Box, Grid, Typography } from "@mui/material";
import { useColorMode } from "~/providers/color-mode";
import EmptyReporting from "~/images/empty-reporting.png";
import EmptyReportingLight from "~/images/empty-reporting-light.png";

export function ReportsEmptyState() {
  const { mode } = useColorMode();

  return (
    <Grid container className="empty-reporting">
      <Grid
        size={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 8,
        }}
      >
        <Box
          component="img"
          src={mode === "light" ? EmptyReportingLight : EmptyReporting}
          alt="Empty reports illustration"
          sx={{ width: "100%", maxWidth: 380, height: "auto" }}
        />
      </Grid>
      <Grid size={12} sx={{ textAlign: "center" }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
          }}
        >
          Time to create your first report!
        </Typography>
        <Typography color="text.secondary">
          Easily run a report from any Mondoo compliance framework page: Just
          click the report icon. <br />
          All the reports you run appear on this page for you to download.
        </Typography>
      </Grid>
    </Grid>
  );
}
